import React, { use, useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import axios from "../../api/axiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ProfileEditPage() {
    const navigate = useNavigate();
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    mobile: "",
    address_street: "",
    address_line2: "",
    address_city: "",
    address_postal: "",
    mailing_street: "",
    mailing_line2: "",
    mailing_city: "",
    mailing_postal: "",
    is_mailing_same: false,
    children: [],
  });
  const [childName, setChildName] = useState("");
  const [childBirthDate, setChildBirthDate] = useState("");

  const fetchProfile = async () => {
        try {

            const response = await axios.get("/v1/profile/getBuddyProfile");

            
            if (response.data.status !== "success") {
                throw new Error("Failed to fetch profile data");
            }
            const data = response.data.data.profile;
            setProfile(data);
            
            // setProfile(data.data.profile);
        } catch (error) {
            console.error( error);
        }
    };

  useEffect(() => {
    // Fetch existing profile data from API and set it to state
  
    fetchProfile();
    }, []);
  // Add a new child to the list
  const handleAddChild = () => {
    if (childName && childBirthDate) {
      setProfile((prev) => ({
        ...prev,
        children: [
          ...prev.children,
          {
            child_name: childName,
            child_birthdate: childBirthDate
          }
        ]
      }));
      setChildName("");
      setChildBirthDate("");
    }
  };

  // Remove a child by index
  const handleRemoveChild = (idx) => {
    setProfile((prev) => ({
      ...prev,
      children: prev.children.filter((_, i) => i !== idx)
    }));
  };

  // Reflect mailing address if 'same as' is checked
  const handleSameAsMailing = (checked) => {
    setProfile(prev => ({
      ...prev,
      is_mailing_same: checked ? true : false,
      ...(checked
        ? {
            mailing_street: prev.address_street,
            mailing_line2: prev.address_line2,
            mailing_city: prev.address_city,
            mailing_postal: prev.address_postal
          }
        : {})
    }));
  };

  // Generic profile field change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
    if (name.startsWith("address_") && profile.is_mailing_same) {
      setProfile((prev) => ({
        ...prev,
        [name]: value,
        [`mailing${name.slice(7)}`]: value // set mailing_ to match address_
      }));
    }
  };

const onSave = async (e) => {
  e.preventDefault();
  try {
    // PATCH or PUT depending on your backend (here using PATCH for a partial/full update)
    // Update the endpoint as needed:
    const res = await axios.put("/v1/profile/updateBuddyProfile", profile);
    if (res.data.status === "success") {
    toast("Profile updated successfully!");
    navigate("/profile"); // Redirect to profile page after save
      // Optionally, refetch or navigate here
    } else {
      toast.error("Save failed: " + (res.data.message || "Unknown error"));
    }
  } catch (error) {
    toast.error(
      "Save failed: " +
        (error.response?.data?.message || error.message || "Unknown error")
    );
  }
};


  // Form & styles
  return (
  <><Navbar />
    <div className="profile-edit-page">
      
          <form
      onSubmit={onSave}
      style={{
        background: "#fff",
        minHeight: "100vh",
        fontFamily: "Nunito, sans-serif",
        padding: "36px",
        maxWidth: 630,
        margin: "0 auto",
        letterSpacing: ".13em",
      }}
    >
      <div style={{
        fontWeight: 700,
        fontSize: "1.15rem",
        paddingBottom: "14px",
        letterSpacing: ".22em",
        marginTop: "6px"
      }}>
        PROFILE
      </div>
      <div style={{ display: "flex", gap: "16px", marginBottom: "18px" }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: ".93em" }}>FIRST NAME</label>
          <input
            name="first_name"
            value={profile.first_name}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: ".93em" }}>LAST NAME</label>
          <input
            name="last_name"
            value={profile.last_name}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>
      </div>
      <div>
        <label style={{ fontSize: ".93em" }}>EMAIL ADDRESS</label>
        <input
          name="email_address"
          type="email"
          disabled
          value={profile.email_address}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>
      <div>
        <label style={{ fontSize: ".93em" }}>MOBILE</label>
        <input
          name="mobile"
          value={profile.mobile}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>

     
        {profile.children.map((child, i) => (
          <div key={i} style={{ background: "#FFFCED", margin: "10px 0 6px", padding: "8px", borderRadius: "5px", display: "flex", alignItems: "center" }}>
            <span style={{ flex: 1 }}>
          {child.first_name} {child.last_name} (
          {child.child_birthdate
            ? new Date(child.child_birthdate).toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric"
              })
            : ""}
          )
            </span>
            <button type="button" onClick={() => handleRemoveChild(i)} style={{ marginLeft: '6px', color: '#F25C5C', background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
          </div>
        ))}

        <div>
          <label style={{ fontSize: ".93em" }}>CHILDS NAME</label>
          <input
            value={childName}
            onChange={e => setChildName(e.target.value)}
            style={inputStyle}
          />
        </div>
        <div>
          <label style={{ fontSize: ".93em" }}>CHILDS BIRTH DATE</label>
          <input
            value={childBirthDate}
            onChange={e => setChildBirthDate(e.target.value)}
            style={inputStyle}
            type="date"
          />
        </div>
        <button type="button" onClick={handleAddChild} style={{
          margin: "8px 0",
          background: "#FFFCCB",
          border: "1px solid #ccc",
          borderRadius: "3px",
          padding: "4px 11px",
          fontSize: ".85em",
          letterSpacing: "0.18em"
        }}>
          ADD CHILD
        </button>

        {/* Address */}
      <div style={{ margin: "22px 0 0" }}>
        <label style={{ fontWeight: 700, fontSize: "1em" }}>ADDRESS</label>
      </div>
      <input
        name="address_street"
        value={profile.address_street}
        onChange={handleChange}
        style={inputStyle}
        placeholder="Street Name"
      />
      <input
        name="address_line2"
        value={profile.address_line2}
        onChange={handleChange}
        style={inputStyle}
        placeholder="Address Line 2"
      />
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <input
          name="address_city"
          value={profile.address_city}
          onChange={handleChange}
          style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
          placeholder="City"
        />
        <input
          name="address_postal"
          value={profile.address_postal}
          onChange={handleChange}
          style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
          placeholder="Postal"
        />
      </div>
      <label style={{fontSize:".92em"}}>
        <input
          type="checkbox"
          checked={profile.is_mailing_same}
          onChange={e => handleSameAsMailing(e.target.checked)}
          style={{ marginRight: 6}}
        />
        SAME AS MAILING ADDRESS
      </label>

      {/* Mailing Address */}
      <div style={{ margin: "22px 0 0" }}>
        <label style={{ fontWeight: 700, fontSize: "1em" }}>MAILING ADDRESS</label>
      </div>
      <input
        name="mailing_street"
        value={profile.mailing_street}
        onChange={handleChange}
        style={inputStyle}
        placeholder="Street Name"
        disabled={profile.is_mailing_same}
      />
      <input
        name="mailing_line2"
        value={profile.mailing_line2}
        onChange={handleChange}
        style={inputStyle}
        placeholder="Address Line 2"
        disabled={profile.is_mailing_same}
      />
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <input
          name="mailing_city"
          value={profile.mailing_city}
          onChange={handleChange}
          style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
          placeholder="City"
          disabled={profile.is_mailing_same}
        />
        <input
          name="mailing_postal"
          value={profile.mailing_postal}
          onChange={handleChange}
          style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
          placeholder="Postal"
          disabled={profile.is_mailing_same}
        />
      </div>
      {/* Save Button */}
      <div style={{
        display: "flex",
        justifyContent: "flex-end"
      }}>
        <button
          type="submit"
          style={{
            marginTop: "28px",
            fontWeight: 800,
            fontSize: "1.2em",
            background: "none",
            border: "none",
            letterSpacing: ".29em",
            color: "#222",
            cursor: "pointer"
          }}
        >
          SAVE
        </button>
      </div>
    </form>
    </div>
  </>
  );
}

const inputStyle = {
  width: "100%",
  margin: "7px 0 14px 0",
  padding: "10px 16px",
  borderRadius: "16px",
  border: "1px solid #F7EBC9",
  background: "none",
  fontSize: "1.07em",
  letterSpacing: ".13em"
};
